var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 340,
    viewBox: "0 0 420 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.857 17.8785C217.307 30.2559 259.757 56.386 300.815 94.8936C337.698 129.963 369.014 170.533 394.762 213.854C314.037 236.546 269.5 264.739 208.26 314.249C173.465 257.863 138.67 218.668 73.951 184.286C96.9158 123.087 131.015 66.7005 174.857 17.8785ZM169.29 0C117.793 55.6984 78.1265 121.024 53.074 191.85C125.448 227.607 161.635 267.49 203.389 339.004C277.154 279.18 321.692 248.924 419.118 224.169C362.75 122.399 272.979 25.4425 169.29 0Z",
    fill: "url(#paint0_linear_964_6484)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4193 57.7615C30.1094 57.7615 15.4955 59.1367 0.881592 62.5749C18.975 96.269 32.1972 121.024 41.9398 151.28C45.4193 120.336 46.8111 88.705 45.4193 57.7615Z",
    fill: "#F48020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.495 21.3166C108.746 8.93916 80.2145 2.06281 50.9866 2.75045C60.0333 53.6354 61.4251 105.896 53.0743 157.468C73.9514 108.646 101.092 62.5746 134.495 21.3166Z",
    fill: "url(#paint1_linear_964_6484)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.085 185.662C208.957 188.413 215.22 189.788 220.787 189.788C221.483 193.226 220.787 197.352 219.395 200.79L207.565 230.359C202.693 241.361 217.307 259.239 227.746 270.241C259.757 248.237 313.342 213.855 353.704 199.415L334.219 175.348C325.172 166.409 300.12 143.029 286.202 149.905L256.278 162.283C252.798 164.346 248.623 164.346 245.144 163.658C244.448 158.157 243.056 151.968 240.272 147.155L240.968 145.092C238.184 138.216 233.313 132.027 227.746 127.213H226.354C224.962 125.15 223.571 123.775 221.483 122.4C218.699 120.337 215.916 118.274 213.132 116.899C208.261 114.836 203.389 114.836 198.518 115.524C192.255 116.899 186.688 119.649 181.816 123.775L179.729 127.901C175.553 132.714 172.77 138.215 171.378 144.404C170.682 149.218 170.682 154.031 172.77 158.845C174.161 161.595 176.249 165.033 179.033 167.096C180.425 169.159 181.816 170.534 183.904 171.91V173.285C188.775 178.786 195.039 183.599 201.998 186.35L204.085 185.662Z",
    fill: "url(#paint2_linear_964_6484)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.6 48.1348C184.6 48.1348 169.986 56.3864 144.933 92.831C127.536 118.273 110.834 156.093 103.179 169.846C115.705 175.347 127.536 182.223 138.67 190.475C142.15 153.343 158.155 118.273 183.208 90.7681C197.126 74.9525 202.693 68.0762 209.652 61.1998L184.6 48.1348Z",
    fill: "url(#paint3_linear_964_6484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_964_6484",
    x1: 53.074,
    y1: 169.501,
    x2: 419.118,
    y2: 169.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#802673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#642975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#522A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_964_6484",
    x1: 50.7082,
    y1: 80.1011,
    x2: 134.495,
    y2: 80.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B33666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_964_6484",
    x1: 170.682,
    y1: 192.645,
    x2: 353.774,
    y2: 192.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8F2473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#802674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#522A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_964_6484",
    x1: 103.04,
    y1: 119.305,
    x2: 209.513,
    y2: 119.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F27123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#DC5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C4485A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B63B63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B33666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.c55bedd5.svg";
export { ForwardRef as ReactComponent };